import axios from "axios";

import config from "../constants/config";

const axiosInstance = axios.create({
  baseURL: config.baseURL,
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    /** In dev, intercepts request and logs it into console for dev */
    config.headers.Authorization = localStorage.getItem("Authorization");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
const get = (path, options, config) => {
  return axiosInstance.get(path, config);
};

export { get };

export default axiosInstance;
